module.exports = __webpack_public_path__ + "static/img/text.e9c25871.png";